import { useCallback, useEffect, useRef } from "react";

export const useOnClickOutside = <T = any>(handler: () => void) => {
  const ref = useRef<T>(null);
  const escapeListener = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handler();
      }
    },
    [handler],
  );

  const clickListener = useCallback(
    (e: MouseEvent) => {
      if (!(ref.current! as any)?.contains(e.target)) {
        handler?.();
      }
    },
    [ref.current, handler],
  );

  useEffect(() => {
    document.addEventListener("click", clickListener);
    document.addEventListener("keyup", escapeListener);
    return () => {
      document.removeEventListener("click", clickListener);
      document.removeEventListener("keyup", escapeListener);
    };
  }, [handler, clickListener, escapeListener]);
  return ref;
};
